import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const RealEstate = () => {
  return (
    <>
      <SEO 
        title="Real Estate Technology Solutions - Abacies Logiciels"
        description="Transform real estate operations with AI-powered property management systems, smart building solutions, and digital platforms for property listings, tenant management, and real estate analytics."
        keywords="real estate technology, property management software, real estate solutions, smart buildings, property analytics, real estate AI"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Real Estate
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Real Estate page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Real Estate. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default RealEstate;
